// Conversion Funnel Chart Component
// Displays lead journey from intake to conversion

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Target } from 'lucide-react';
import { COLORS } from './analyticsConstants';

const ConversionFunnelChart = ({ funnel }) => {
  if (!funnel) return null;

  return (
    <Card className="border-slate-200" data-testid="conversion-funnel">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Target className="w-5 h-5 text-teal-500" />
          Conversion Funnel
        </CardTitle>
        <CardDescription>Lead journey from intake to conversion</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {funnel.funnel.map((stage, idx) => (
            <div key={stage.stage} className="relative">
              <div className="flex items-center justify-between mb-1">
                <span className="text-sm font-medium text-slate-700">{stage.stage}</span>
                <span className="text-sm text-slate-500">{stage.count} ({stage.percentage}%)</span>
              </div>
              <div className="h-8 bg-slate-100 rounded-lg overflow-hidden">
                <div 
                  className="h-full rounded-lg transition-all duration-500"
                  style={{ 
                    width: `${stage.percentage}%`,
                    backgroundColor: idx === 0 ? COLORS.primary : 
                      idx === funnel.funnel.length - 1 ? COLORS.success : 
                      `rgba(13, 148, 136, ${1 - (idx * 0.15)})`
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default ConversionFunnelChart;
